module.exports = __webpack_public_path__ + "static/media/emily-squareTiny.ff2143aa.jpg";